module.exports = __webpack_public_path__ + "static/img/theme3.8b5ba80d.png";